import React, {useState, useEffect} from 'react';
import './businessEducationIndustries.scss';
import {ReactComponent as ELEMENT_02} from 'assets/business-education-assets/elements/be_element_02.svg'
import INDUSTRIES_IMAGE from 'assets/business-education-assets/inductries_image.png';
import {industryData} from "../../../../data/industriesData";
import {IndustryDataType, sectionId} from 'models';
import {HeadingElement} from "components";
import {Industry} from "./InductrySections";

const Industries = () => {
        const [links, setLinks] = useState<IndustryDataType[]>(industryData);


        useEffect(() => {
            setLinks((prev) => (prev.filter(data => data.enabled === true)))
        }, []);

        const setActiveLink = (id: sectionId) => {
            setLinks((prev) => {
                return prev.map((data) => (data.id === id ?
                    {...data, isActive: true} : {...data, isActive: false}))
            })
        }

        return (
            <div className={'business_industries'} id={"business_industries"}>
                <div className="business_industries_wrapper">
                    <div className="business_industries_wrapper_top">
                        <ELEMENT_02 className={'business_industries_wrapper_top_element_02'}/>
                        <div className="business_industries_wrapper_top_content">
                            <div className="business_industries_wrapper_top_content_left">
                                <HeadingElement/>
                                <h1>Business Industries In Jamaica</h1>
                                <p>The Small Business Association of Jamaica is a community of businesses and experts that enforces 
                                    the development of the Jamaica business sector; assists small businesses in a wide variety of 
                                    industries to help them start and grow their businesses.
                                    <br/><br/>Learn more about your desired business industry below and find
                                    out how we can help you become successful. </p>
                            </div>
                            <div className="business_industries_wrapper_top_content_right">
                                <img src={INDUSTRIES_IMAGE} alt=""/>
                            </div>
                        </div>
                    </div>
                    <div className="business_industries_wrapper_middle">
                        <h1>Industry</h1>
                        <p>Please select industry to learn more.</p>
                        <div className="business_industries_wrapper_middle_options">
                            {links.map(({name, isActive, id}, index) => (
                                <div
                                    className={["business_industries_wrapper_middle_options_option",
                                        isActive ? "link_active" : null].join(' ')}
                                    onClick={() => setActiveLink(id)}
                                    key={name + id + index}
                                >
                                    {name}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="business_industries_wrapper_bottom">
                        {links.map(({heading, description, image, cards, paragraph, id, isActive}, index) => (
                            isActive &&
                            <Industry key={heading + id + index} heading={heading} description={description} image={image}
                                      cards={cards} paragraph={paragraph} name={''} route={''}
                                      isActive={false}
                                      id={id}/>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
;

export default Industries;

